<template>
  <div class="pagination-element">
    <div
      class="content"
      :tabindex="disabled ? -1 : 0"
      @click="$emit('onClicked')"
      @keypress="$emit('onClicked')"
    >
      <SvgDisplay
        src="Icon-Chevron-Right"
        class="arrow"
        :class="{ disabled: disabled }"
      ></SvgDisplay>
    </div>
  </div>
</template>
<script lang="ts" setup>
import SvgDisplay from './SvgDisplay.vue'
defineEmits<{
  (event: 'onClicked'): void
}>()
defineProps<{
  disabled?: boolean
}>()
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';

.pagination-element {
  display: flex;
  width: 48px;
  height: 48px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
}
.content {
  @include font-mixins.desktop-bold-paragraph;
  color: variables.$color-primary;
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  box-sizing: border-box;
  &:focus {
    border: 2px solid variables.$color-primary-light;
    outline-color: variables.$color-primary-light !important;
  }
  .arrow {
    &.disabled {
      color: variables.$color-disabled;
      cursor: not-allowed;
    }
  }
}
</style>
